import { FC } from "react";
import { Button } from "antd";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { MdError } from "react-icons/md";
import { SuccessBannerIcon } from "src/assets/Icons";

type Props = {
  error: any;
  onBack: () => void;
  onClose: () => void;
};

const RechargeResultStep: FC<Props> = ({ error, onBack, onClose }) => {
  const { t } = useTranslation();
  const isError = !!error;

  return (
    <div className="font-inter flex flex-col items-center gap-8 p-4 pb-2 text-center">
      <div className={classNames("flex h-28 w-28 items-center justify-center rounded-full", isError ? "bg-background-danger" : "bg-background-success")}>
        {isError ? <MdError className="text-font-danger h-16 w-16" /> : <SuccessBannerIcon className="text-font-success h-16 w-16" />}
      </div>

      <div className="flex flex-col gap-2">
        <div className={classNames("text-xl font-bold", isError ? "text-font-danger" : "text-font-default")}>
          {isError ? t("Topup.rechargeFailed") : t("Topup.rechargeComplete")}
        </div>
        <div className="text-sm text-font-subtle">
          {isError ? (error?.data?.message ?? t("Topup.genericError")) : t("Topup.rechargeSuccessMessage")}
        </div>
      </div>

      <div className="flex w-full flex-col gap-2 pt-1">
        <Button type="primary" size="large" block className="bg-background-primary! font-semibold!" onClick={onBack}>
          {isError ? t("Topup.tryAgain") : t("Topup.rechargeMore")}
        </Button>
        <Button type="text" block onClick={onClose}>
          {isError ? t("Topup.goBack") : t("Topup.goHome")}
        </Button>
      </div>
    </div>
  );
};

export default RechargeResultStep;
